var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dark",attrs:{"id":"app"}},[_c('div',{staticClass:"bg-CONFIRMED bg-COMPLETED bg-CLIENT_CONFIRMED bg-PENDING, bg-POSTPONED, bg-FAILED bg-LATE_CANCELLED bg-LIVE bg-RECEIVED bg-CANCELLED bg-AWAITING_SIGNAL bg-"}),_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }